// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/vant/lib/index.css
// module id = 204
// module chunks = 27